document.addEventListener('DOMContentLoaded', function() {
    document.addEventListener('change', function(event) {
        var target = event.target;
        if (target.matches('.grid.product-grid input[type="radio"]')) {
            var productGrid = target.closest('.grid.product-grid');
            var sectionId = productGrid.getAttribute('data-section-id');
            var variantDataMap = window['variantDataMap' + sectionId.replace(/-/g, '_')];
            
            var card = target.closest(`.card-product-custom-div[data-section-id="${sectionId}"]`);
            var variantId = target.getAttribute('data-variant-id');
            var variantData = variantDataMap[variantId];
  
            if (!variantData) {
                console.log('No data found for variant:', variantId);
                return;
            }

            // Update the product image with lazy loading logic
            var productImageElement = card.querySelector('.card__media img');
            if (productImageElement) {
                // Update src and srcset for responsive images
                var dynamicSrcset = [
                    variantData.imageUrl + '?width=165 165w',
                    variantData.imageUrl + '?width=360 360w',
                    variantData.imageUrl + '?width=533 533w',
                    variantData.imageUrl + '?width=720 720w',
                    variantData.imageUrl + '?width=940 940w',
                    variantData.imageUrl + '?width=1066 1066w'
                ].join(', ');
                productImageElement.srcset = dynamicSrcset;
                productImageElement.src = variantData.imageUrl;
            } else {
                console.log('No product image element found in this card.');
            }

            // Update the product URL
            var productLinks = card.querySelectorAll('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]');
            productLinks.forEach(function(link) {
                link.href = variantData.productUrl;
            });
        }
    });
});